export * from "ce/utils/autocomplete/entityDefGeneratorMap";
import { entityDefGeneratorMap as CE_entityDefGeneratorMap } from "ce/utils/autocomplete/entityDefGeneratorMap";
import { ENTITY_TYPE } from "ee/entities/DataTree/types";
import type { EntityDefGeneratorMap } from "ce/utils/autocomplete/entityDefGeneratorMap";
import {
  flattenDef,
  generateTypeDef,
} from "utils/autocomplete/defCreatorUtils";
import type { Def } from "tern";
import { omit } from "lodash";
import { EVALUATION_PATH } from "utils/DynamicBindingUtils";
import {
  isJSModuleInstance,
  isQueryModuleInstance,
} from "ee/workers/Evaluation/evaluationUtils";
import { ModuleInstanceDefMap } from "./EntityDefinitions";
import type {
  ActionEntityConfig,
  JSActionEntityConfig,
  JSModuleInstanceEntity,
  ModuleInstanceEntityConfig,
  QueryModuleInstanceEntity,
} from "ee/entities/DataTree/types";
import { MODULE_TYPE } from "ee/constants/ModuleConstants";

export const entityDefGeneratorMap: EntityDefGeneratorMap = {
  ...CE_entityDefGeneratorMap,
  [ENTITY_TYPE.MODULE_INPUT]: (props) => {
    const { def, entity, entityMap, extraDefsToDefine } = props;
    const filteredEntity = omit(entity, "ENTITY_TYPE", EVALUATION_PATH);
    const inputEntityDef: Def = {};

    Object.entries(filteredEntity).forEach(([inputName, inputValue]) => {
      inputEntityDef[inputName] = generateTypeDef(
        inputValue,
        extraDefsToDefine,
      );
    });

    def["inputs"] = inputEntityDef;
    flattenDef(def, "inputs");

    entityMap.set("inputs", {
      type: ENTITY_TYPE.MODULE_INPUT,
      subType: ENTITY_TYPE.MODULE_INPUT,
    });
  },
  [ENTITY_TYPE.ACTION]: (props) => {
    const { configTree, entityName } = props;
    const entityConfig = configTree[entityName] as ActionEntityConfig;
    const moduleInstanceId = entityConfig["moduleInstanceId"];

    if (!moduleInstanceId) {
      CE_entityDefGeneratorMap[ENTITY_TYPE.ACTION](props);
    }
  },
  [ENTITY_TYPE.JSACTION]: (props) => {
    const { configTree, entityName } = props;
    const entityConfig = configTree[entityName] as JSActionEntityConfig;
    const moduleInstanceId = entityConfig["moduleInstanceId"];

    if (!moduleInstanceId) {
      CE_entityDefGeneratorMap[ENTITY_TYPE.JSACTION](props);
    }
  },
  [ENTITY_TYPE.MODULE_INSTANCE]: (props) => {
    const { configTree, def, entity, entityMap, entityName } = props;
    const entityConfig = configTree[entityName] as ModuleInstanceEntityConfig;

    if (entityConfig.rootModuleInstanceId) return;

    if (isQueryModuleInstance(entity)) {
      const queryEntity = entity as QueryModuleInstanceEntity;

      def[entityName] = ModuleInstanceDefMap[queryEntity.type](props);
      flattenDef(def, entityName);
      entityMap.set(entityName, {
        type: ENTITY_TYPE.MODULE_INSTANCE,
        subType: MODULE_TYPE.QUERY,
      });
    }

    if (isJSModuleInstance(entity)) {
      const jsEntity = entity as JSModuleInstanceEntity;

      def[entityName] = ModuleInstanceDefMap[jsEntity.type](props);
      flattenDef(def, entityName);
      entityMap.set(entityName, {
        type: ENTITY_TYPE.MODULE_INSTANCE,
        subType: MODULE_TYPE.JS,
      });
    }
  },
};
